/**
 * Canonical unit list for offer positions.
 *
 * Each entry maps:
 *  - `value`  — the stored string (used in DB and ZUGFeRD XML)
 *  - `label`  — human-readable name shown in dropdowns
 *  - `facturX` — UN/CEFACT unit code for ZUGFeRD (mirrors the mapping in server/utils/buildFacturXData.ts)
 */
export type OfferUnit = {
  value: string;
  label: string;
  facturX: string;
};

export const OFFER_UNITS: OfferUnit[] = [
  { value: 'Stk',     label: 'Stk - Stück',              facturX: 'H87' },
  { value: 'h',       label: 'h - Stunde',                facturX: 'HUR' },
  { value: 'Lh',      label: 'Lh - Lohnstunde',           facturX: 'LH'  },
  { value: 'psch',    label: 'psch - Pauschale',           facturX: 'H87' },
  { value: 'm',       label: 'm - Meter',                  facturX: 'MTR' },
  { value: 'Lfm',     label: 'Lfm - Laufmeter',            facturX: 'MTR' },
  { value: 'm²',      label: 'm² - Quadratmeter',          facturX: 'MTK' },
  { value: 'm³',      label: 'm³ - Kubikmeter',            facturX: 'MTQ' },
  { value: 'kg',      label: 'kg - Kilogramm',             facturX: 'KGM' },
  { value: 't',       label: 't - Tonne',                  facturX: 'TNE' },
  { value: 'l',       label: 'l - Liter',                  facturX: 'LTR' },
  { value: 'km',      label: 'km - Kilometer',             facturX: 'KMT' },
];

/** Just the value strings, for validation and datalist rendering. */
export const OFFER_UNIT_VALUES = OFFER_UNITS.map((u) => u.value);
